import { getQueryParams } from "../../utils/filters";
import Policy, { HIPAA } from "../../components/Policy";
import React from "react";
import { withRouter } from "react-router-dom";

const HipaaPolicyPage = (props) => {
    const version = getQueryParams("version", props.location.search);

    return <Policy policyType={HIPAA} version={version} />;
};

export default withRouter(HipaaPolicyPage);
